import { stitch } from 'keo';
import PropTypes from 'prop-types';
import r from 'render-dom';

import { MePropType } from 'proptypes/records';
import { fetchMe } from 'redux/me/actions';
import { editInUi } from 'redux/ui/actions';
import { getJwt } from 'utils/jwt';

import NavigationBar from './NavigationBar';

const propTypes = {
    editShowSideMenu: PropTypes.func.isRequired,
    isLoggedIn: PropTypes.bool,
    me: MePropType.isRequired,
    pathname: PropTypes.string.isRequired,
    showSideMenu: PropTypes.bool.isRequired,
};

const render = ({ props }) => {
    const { editShowSideMenu, ...passProps } = props;
    return (
        r(NavigationBar, {
            ...passProps,
            isLoggedIn: Boolean(getJwt()),
            toggleSideMenu: () => editShowSideMenu(!props.showSideMenu),
        })
    );
};

export default stitch(
    { propTypes, render },
    ({ me, router, ui }) => {
        const location = router.locationBeforeTransitions || window.location;

        return {
            me: me.get('data'),
            pathname: location.pathname,
            showSideMenu: ui.getIn(['navigation', 'showSideMenu'], false),
        };
    },
    {
        editShowSideMenu: editInUi(['navigation', 'showSideMenu']),
        fetchMe,
    }
);



// WEBPACK FOOTER //
// ./src/components/public/Navigation/index.js